import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from './PositiveToast';

const UpdatedToast = ({ name }) => (
  <PositiveToast className="aridhia-updated-toast">
    <FormattedMessage id="toast.updated" values={{ name }} />
  </PositiveToast>
);

export default UpdatedToast;
